import { useState, useEffect } from "react";
import config from "../../../config/config";
import { refreshToolTipTableData } from "../../../observers/dataObserver";
import AddToolTipForm from "./addToolTipForm";

// Styles
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 10,
};

const modalStyle = {
  background: "white",
  borderRadius: "8px",
  width: "320px",
  padding: "20px",
  position: "relative",
  textAlign: "left",
};

const closeButtonStyle = {
  position: "absolute",
  top: "10px",
  right: "10px",
  background: "transparent",
  border: "none",
  fontSize: "18px",
  cursor: "pointer",
  color: "#333",
};

const AddTooltipsFormModal = ({ show, onClose, initialData }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id:"",
    LabelName: "",
    FieldName: "",
    ToolTipText: "",
  });

  // Populate formData with initialData when modal is opened
  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = localStorage.getItem("token");
  
    const payload = {
      tableName: "ToolTips",
      row: {
        id: formData.id, // ✅ Include if editing an existing row
        Name: formData.FieldName,
        Tooltip: formData.ToolTipText,
      }
      // status: "Activate" // 👈 optional, if needed like in toggleRowStatus
    };
  
    console.log("📤 Submitting payload:", payload);
  
    try {
      const response = await fetch(`${config["backend-url"]}/Change_Required_Table`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
  
      if (response.ok) {
        const result = await response.json();
        console.log("✅ Tooltip updated successfully:", result);
        refreshToolTipTableData.push("refresh");
        onClose();
      } else {
        const errorText = await response.text();
        console.error("❌ Failed to update tooltip:", errorText);
      }
    } catch (error) {
      console.error("❌ Network or server error:", error);
    } finally {
      setLoading(false);
    }
  };
  


  if (!show) return null;

  return (
    <div className="modal" style={overlayStyle}>
      <div className="modal-content" style={modalStyle}>
        <h4 style={{ marginTop: 0, marginBottom: "20px" }}>Edit Tooltip</h4>

        <button
          onClick={onClose}
          style={closeButtonStyle}
          aria-label="Close modal"
        >
          ×
        </button>

        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            ⏳ Updating Tooltip...
          </div>
        ) : (
          <AddToolTipForm
            formData={formData}
            onChange={handleChange}
            onSubmit={handleSubmit}
            onCancel={onClose}
          />
        )}
      </div>
    </div>
  );
};

export default AddTooltipsFormModal;
